import { Optional } from '../utils/Util';

export const VALUE_UNDEFINED = 'UNDEFINED';

export interface TableState {
  // RankingTable用
  primaryColumn?: { columnId: string; desc: boolean };
  pageIndexOrRowId?: number | string;
  visibleRowIdPattern?: Optional<string>;
  // HistoryTable用
  showAll?: boolean;
}

export interface TableSectionState {
  optionsState: Record<string, string>;
  tableState: TableState;
}

export type PageState = {
  initialTable: Optional<string>;
  tableStates: Record<string, TableSectionState>;
};
